/**
 * Title overrides for sidebar items.
 * Keys are module identifiers; values replace the backend title.
 */
export const SIDEBAR_TITLE_OVERRIDES: Record<string, string> = {
  uibilling: "POS",
};

/**
 * Sidebar category definitions.
 * Modules are rendered in the order they appear here.
 * Modules not listed fall into an "Other" group at the end.
 */
export interface SidebarCategory {
  label: string;
  modules: string[];
}

export const SIDEBAR_CATEGORIES: SidebarCategory[] = [
  {
    label: "Sales",
    modules: [
      "uidashboard",
      "uibilling",
      "uitableorder",
      "uimassinvoice",
      "uimassinvoicesales",
      "uimassstocktransfer",
      "uicashentry",
    ],
  },
  {
    label: "Inventory",
    modules: [
      "uigrn",
      "uigrnalcohol",
      "uigrn-nonalcohol",
      "uigrnreturn",
      "uigrn-nonalcoholreturn",
      "uiinventory",
      "uistocktransfer",
      "uigodownstock",
    ],
  },
  {
    label: "Masters",
    modules: [
      "uimasters",
      "uimasspriceupdate",
      "uisellingpricemaster",
      "uisupplier",
      "uidistmaster",
      "uischememaster",
      "uiwobmaster",
      "uitableorderconfig",
    ],
  },
  {
    label: "Reports",
    modules: ["uireportsv2", "uicustomreports", "uitracker", "uitransactions"],
  },
  {
    label: "Finance",
    modules: [
      "uisupplierbillpayreq",
      "uisupplierbillpay",
      "uistoreexpensesv3",
      "uistoreexpensescorrection",
      "uipurchaseplanning",
    ],
  },
  {
    label: "Admin",
    modules: [
      "uiadministration",
      "uicontrolmanagement",
      "uiuser",
      "uishops",
      "uionboarding",
      "uicronjobs",
      "uiscript",
      "uiutilities",
    ],
  },
];
